export default __webpack_public_path__ + "static/media/vip.0b02def4.svg";